import { render, staticRenderFns } from "./formBuilder.vue?vue&type=template&id=0af2c8ee"
import script from "./formBuilder.vue?vue&type=script&lang=js"
export * from "./formBuilder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports